module.exports = __webpack_public_path__ + "static/img/banner_01.687c864b.png";